import React from 'react';
import useBodyScrollLock from '../hooks/useBodyScrollLock';

/**
 * 汎用確認モーダルコンポーネント
 *
 * 使用例:
 *   <ConfirmModal
 *     isOpen={showModal}
 *     title="確認"
 *     onConfirm={handleConfirm}
 *     onCancel={handleCancel}
 *   >
 *     <p>本当に実行しますか？</p>
 *   </ConfirmModal>
 */
function ConfirmModal({
  isOpen,
  title,
  children,
  onConfirm,
  onCancel,
  confirmText = 'はい、実行する',
  cancelText = 'いいえ',
  confirmClassName = 'modal-button-confirm',
  disabled = false,
}) {
  useBodyScrollLock(isOpen);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">{title}</h3>
        <div style={{ margin: '0 0 20px 0' }}>{children}</div>
        <div className="modal-actions">
          {onCancel && (
            <button
              className="modal-button-cancel"
              onClick={onCancel}
              disabled={disabled}
            >
              {cancelText}
            </button>
          )}
          <button
            className={confirmClassName}
            onClick={onConfirm}
            disabled={disabled}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
